import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Cabecalho,
  ContainerAcoes,
  Filtro,
  IconeEditar,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip,
  Visao
} from 'src/componentes'
import {
  Container,
  Form,
  ContainerDados75,
  Dados
} from 'src/componentes/styles/filtro'
import {
  DataInputUnform,
  InputUnform,
  SelectOpcao,
  SelectUnform
} from 'src/componentes/unform'
import { RotasTurmaCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import {
  TipoOrdenacao,
  CursoSituacao,
  SituacaoTurmaCertificacao,
  DadosPesquisaTurmaCertificacao
} from 'src/tipos'

import { ContainerCertificacao } from '../styles'
import { OPCOES_TIPO } from './opcoes-select'
import { TabelaComEstilos } from './styles'
// import { TabelaComEstilos } from './styles'

export const PaginaTurmasCertificacao: React.FC = () => {
  const { visao } = AutenticacaoContainer.useContainer()
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id

  const history = useHistory()
  const [
    dadosPesquisa,
    definirDadosPesquisa
  ] = useState<DadosPesquisaTurmaCertificacao>(null)
  const tabelaRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState(null)
  const [usuarioOpcoes, definirUsuarioOpcoes] = useState<SelectOpcao[]>([])

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const parametrosComuns = {
      usuarioId,
      visao,
      nome: dadosPesquisa?.nome,
      status: dadosPesquisa?.status,
      tipo: dadosPesquisa?.tipo,
      dataCriacaoTurma: dadosPesquisa?.dataCriacaoTurma,
      usuarioPerfilFiltro: dadosPesquisa?.usuarioPerfilFiltro,
      chaveOrdenacao,
      ordem
    }

    const requisitarTurmas = async (
      pagina: number,
      quantidade: number,
      isPaginated: number
    ) =>
      Api.RequisitarListaTurmasCertificacao(
        parametrosComuns.usuarioId,
        parametrosComuns.visao,
        isPaginated,
        parametrosComuns.nome,
        dadosPesquisa?.status,
        dadosPesquisa?.tipo,
        dadosPesquisa?.dataCriacaoTurma,
        parametrosComuns.usuarioPerfilFiltro,
        pagina,
        quantidade,
        parametrosComuns.chaveOrdenacao,
        parametrosComuns.ordem
      )

    const dados = await requisitarTurmas(numeroPaginas, quantidadePorPagina, 1)
    if (!dados) return null

    if (visao !== Visao.ParceiroCertificacao) {
      const dadosTodos = await requisitarTurmas(1, 0, 0)
      const usuariosUnicos = dadosTodos.registros
        .map(dado => ({
          id: dado.usuarioPerfilId,
          texto: dado.usuarioPerfilNome
        }))
        .filter(
          (valor, indice, self) =>
            self.findIndex(v => v.id === valor.id) === indice
        )

      definirUsuarioOpcoes([{ id: '', texto: 'Todos' }, ...usuariosUnicos])
    }

    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisaTurmaCertificacao) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  return (
    <ContainerCertificacao>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Turmas"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Turmas'
            }
          ]}
        />
        {visao === Visao.ParceiroCertificacao && (
          <Botao
            type="button"
            texto="Incluir"
            tema="Secundario"
            onClick={() => history.push(RotasTurmaCertificacao.Cadastro)}
          />
        )}
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao: CursoSituacao[CursoSituacao.Todos],
            modalidade: 'Todas'
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="nome" label="Nome da Turma" />
            </ContainerDados75>
            <ContainerDados75>
              <SelectUnform
                id="slct_status"
                name="status"
                label="Situação da Turma"
                placeholder="Selecione"
                opcoes={[
                  {
                    id:
                      SituacaoTurmaCertificacao[
                        SituacaoTurmaCertificacao.Finalizada
                      ],
                    texto:
                      SituacaoTurmaCertificacao[
                        SituacaoTurmaCertificacao.Finalizada
                      ]
                  },
                  {
                    id:
                      SituacaoTurmaCertificacao[
                        SituacaoTurmaCertificacao.Cancelada
                      ],
                    texto:
                      SituacaoTurmaCertificacao[
                        SituacaoTurmaCertificacao.Cancelada
                      ]
                  },
                  {
                    id:
                      SituacaoTurmaCertificacao[
                        SituacaoTurmaCertificacao.Emandamento
                      ],
                    texto: 'Em Andamento'
                  },
                  {
                    id: 'Todas',
                    texto: 'Todas'
                  }
                ]}
              />
            </ContainerDados75>
          </Container>
          <Container>
            <ContainerDados75>
              <SelectUnform
                id="slct_tipo"
                name="tipo"
                label="Tipo da Turma"
                placeholder="Selecione"
                opcoes={OPCOES_TIPO}
              />
            </ContainerDados75>
            {visao !== Visao.ParceiroCertificacao && (
              <ContainerDados75>
                <SelectUnform
                  id="slct_usuario"
                  name="usuarioPerfilFiltro"
                  label="Parceiro"
                  margemInferior={false}
                  opcoes={usuarioOpcoes}
                />
              </ContainerDados75>
            )}
            <ContainerDados75>
              <DataInputUnform
                name="dataCriacaoTurma"
                label="Data de criação"
              />
            </ContainerDados75>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <TabelaComEstilos
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'tipo',
              Texto: 'Tipo',
              Renderizar: (linha: any) => {
                if (linha.tipo === 'Aberta') return 'Entrada de alunos diária'
                if (linha.tipo === 'Fechada') {
                  return 'Entrada de alunos até data estipulada'
                }
                return linha?.status ?? '-'
              },
              ComOrdenacao: true
            },
            {
              Chave: 'status',
              Texto: 'Situação',
              Renderizar: (linha: any) => {
                if (linha.status === 'Emandamento') return 'Em andamento'
                if (linha.status === 'AguardandoInicio') {
                  return 'Aguardando Inicio'
                }
                return linha?.status ?? '-'
              },
              ComOrdenacao: true
            },
            {
              Chave: 'dataInicio',
              Texto: 'Data Início',
              Renderizar: (linha: any) =>
                linha.dataInicio
                  ? new Date(linha.dataInicio).toLocaleDateString('pt-BR')
                  : '-',
              ComOrdenacao: true
            },
            {
              Chave: 'dataFim',
              Texto: 'Data Fim',
              Renderizar: (linha: any) =>
                linha.dataFim
                  ? new Date(linha.dataFim).toLocaleDateString('pt-BR')
                  : '-',
              ComOrdenacao: true
            },
            {
              Chave: 'curso',
              Texto: 'Curso',
              Renderizar: (linha: any) => linha.cursoCertificacao?.nome ?? '-',
              ComOrdenacao: true
            },
            ...(visao !== Visao.ParceiroCertificacao
              ? [
                  {
                    Chave: 'usuarioPerfilNome',
                    Texto: 'Nome do parceiro',
                    ComOrdenacao: false
                  }
                ]
              : []),
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(
                        `${RotasTurmaCertificacao.Edicao}/${linha.id}`,
                        {
                          modalidade: linha.modalidade
                        }
                      )
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasTurmaCertificacao.Edicao}/${linha.id}/${linha.modalidade}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    place="bottom"
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </ContainerCertificacao>
  )
}

export { default as PaginaCadastroTurmasCertificacao } from './cadastro'
